import React from "react";
import MinusButton from "../assets/minus.svg";
import PlusButton from "../assets/plus.svg";
import "../App.css";
import ReactTooltip from "react-tooltip";
import { generateId } from "../idGenerator";
import ReactGA from 'react-ga';

class Problem extends React.Component {

    constructor(props) {
        super(props);

        if (isNaN(this.props.id)) {
            this.id = generateId("problem-");
        } else {
            this.id = `problem-${this.props.id}`
        }

        this.state = { open: false };
    }

    componentDidMount() {
        ReactTooltip.rebuild();
    }

    componentDidUpdate() {
        ReactTooltip.rebuild();
    }

    render() {
        return <div className="Tile">
            <div className="ErrorTile" onClick={() => {
                if (!this.state.open) {
                    this.setState({ open: true });
                    this.sendOpenAnalytics();
                }
            }}>
                <div className="ErrorMessage">
                    <h4>
                        {this.props.title}
                        <div className="Indent-0">
                            {this.props.tip ? `(Tip: ${this.props.tip})` : ""}
                        </div>
                    </h4>
                </div>
                {!this.state.open && (
                    <div
                        className="ButtonHolder"
                        data-tip="Open the explanation."
                        data-for="openclose-tooltip"
                        data-effect="solid"
                        data-place="left"
                    >
                        <img
                            onClick={() => { this.setState({ open: true }); this.sendOpenAnalytics(); }}
                            src={PlusButton}
                            alt="down-button"
                            width="20"
                            height="20"
                        ></img>
                    </div>
                )}
                {this.state.open && (
                    <div
                        className="ButtonHolder"
                        data-tip="Close the explanation."
                        data-for="openclose-tooltip"
                        data-effect="solid"
                        data-place="left"
                    >
                        <img
                            onClick={() => { this.setState({ open: false }); this.sendCloseAnalytics(); }}
                            src={MinusButton}
                            alt="up-button"
                            width="20"
                            height="20"
                        ></img>
                    </div>
                )}
            </div>

            {this.state.open && (
                <div className="StrategyContainer">
                    {this.props.children}
                </div>
            )}
        </div>;
    }

    sendOpenAnalytics() {
        this.sendAnalytics("open");
    }

    sendCloseAnalytics() {
        this.sendAnalytics("close");
    }

    sendAnalytics(action) {
        ReactGA.event({
            category: "problem-interaction",
            label: `${window.location.pathname}-${this.id}`,
            action: action
        });
    }
}

export default Problem;
